import { TABLE_UNMOUNT } from '../../Table/tableActions';
import {
    ERRORED_PAYOUTS_FAILURE,
    ERRORED_PAYOUTS_LOAD,
    ERRORED_PAYOUTS_SUCCESS
} from './erroredPayoutsActions';
import {
    get,
    isEqual
} from 'lodash';
import { createSelector } from 'reselect';
import { getEntityByName } from '../../appEntities';

export default function reducer(state = {}, action = {}) {
    let newState;

    switch (action.type) {
        case TABLE_UNMOUNT:
            newState = {
                ...state,
                erroredPayouts: []
            };

            return isEqual(state, newState) ? state : newState;

        case ERRORED_PAYOUTS_LOAD:
            newState = {
                ...state,
                erroredPayouts: [],
                error: null,
                loading: true
            };

            return isEqual(state, newState) ? state : newState;

        case ERRORED_PAYOUTS_SUCCESS:
            newState = {
                ...state,
                erroredPayouts: action.erroredPayouts,
                count: action.count,
                loading: false,
                pages: action.pages,
                hasMore: action.hasMore,
                offset: action.offset,
                limit: action.limit
            };

            return isEqual(state, newState) ? state : newState;

        case ERRORED_PAYOUTS_FAILURE:
            newState = {
                ...state,
                count: 0,
                error: action.error,
                loading: false,
                pages: 0
            };

            return isEqual(state, newState) ? state : newState;
        default:
            return state;
    }
}

export const getErroredPayoutsEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'erroredPayouts')
);

export const getPages = createSelector(
    getErroredPayoutsEntity,
    (entity) => get(entity, 'pages')
);

export const getCount = createSelector(
    getErroredPayoutsEntity,
    (entity) => get(entity, 'count')
);

export const getIsErroredPayoutsLoading = createSelector(
    getErroredPayoutsEntity,
    (entity) => get(entity, 'loading')
);

export const getErroredPayouts = createSelector(
    getErroredPayoutsEntity,
    (entity) => get(entity, 'erroredPayouts')
);

export const getErroredPayoutsError = createSelector(
    getErroredPayoutsEntity,
    (entity) => get(entity, 'error')
);

export const getErroredPayoutsErrorMessage = createSelector(
    getErroredPayoutsError,
    (error) => get(error, 'message')
);

export const getHasMore = createSelector(
    getErroredPayoutsEntity,
    (entity) => get(entity, 'hasMore')
);
